import React, {useState, useRef, useEffect, Fragment} from 'react';
import SliderRegistriTemplates from '../SliderRegistriTemplates'
import { useStateContext } from '../../context/StateContext';
import Divider from '../frontend_components/Divider';
import TrueFalseToggle from '../TrueFalseToggle';
import VisDiv from '../frontend_components/VisDiv';
import TextHighlight from '../frontend_components/TextHighlight';
import {FiEdit} from 'react-icons/fi'
import {AiFillCloseCircle} from 'react-icons/ai';
import NonConformityPin from '../NonConformityPin';
import SaveButton from '../frontend_components/SaveButton';
import { errorAlert, keyId, sortByLabel, successAlert, addValueForDropdown } from '../../lib/utils';
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import Loading from '../Loading';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';

const AnalisiNonConformitaEProdotti = ({data}) => {
    const {
        sUser,
        customer,
        setCustomer,
        setSUser, 
        setLoading,
        loading,
        LDB,
        setDefaultOfferMenu,
        setNewNonConformity,
        setNewCustomerProduct,
        setClients,
    } = useStateContext();

    const queryClient = useQueryClient()
    const {customerProducts, nonConformities, templateRegisters, presidioModules, deviceProperties} = data

    const[registerTemplateFilter, setRegisterTemplateFilter] = useState()
    const[empty, setEmpty] = useState(false)
    const[supply, setSupply] = useState(false)
    const[sub, setSub] = useState(false)
    const[assigned, setAssigned] = useState(false)
    
    const [editDocument, setEditDocument] = useState(undefined)
    const [customerProductList, setCustomerProductList] = useState([])
    const[toggleEdit, setToggleEdit] = useState(false)
    const editSizeLeft = toggleEdit ? {width: "30%" } : {}
    const editSizeRight = toggleEdit ? {width: "70%" } : {}

    const registerCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.(x=>!x?.supply)

    

    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {
    
            await queryClient.cancelQueries({ queryKey: ["customerProducts"] })
            const previousData = queryClient.getQueryData(["customerProducts"])
            const doc = newDoc?.doc
            queryClient.setQueryData(["customerProducts"], (old) =>{ 
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!==doc?._id), {...doc}]
                return newData
            })
            return { previousSites: previousData}
        },
        onError:()=>{
            errorAlert("Errore: il documento non é stato aggiornato")
        }
    
    })

    const updateDocManually = () => {
        const doc = !Array.isArray(registerCustomerProducts) ? {} : registerCustomerProducts?.find?.((x)=>x?._id == "6197a2f8-b2ae-487c-a087-67e1d4781e34")
        const updatedDoc = {...doc,  supplierProducts: !Array.isArray(doc?.supplierProducts) ? [] : doc?.supplierProducts?.filter?.((x)=>x)}
        console.log(doc, updatedDoc)
        updateDocument({doc: updatedDoc})
    }
    const viewBadProducts = () => {
        const idLaw = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.law?._id)
        const idProducts = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.supplierProducts?.some?.(y=>y?._id))
        return ({idLaw, idProducts})
    }

    const updateCustomerProducts = () => {
        const nonConformity = editDocument?.nonConformity
        const referenceDoc = {_ref: nonConformity?._id, _type:"reference", _key: keyId()}
        console.log("customerProductList", customerProductList, referenceDoc, editDocument)

        const createNonConformities = async (req, res) => {
        
            const queue = new PromiseQueue({
              concurrency: 12,
              intervalCap: 15,
              interval: 700,
            })
            setLoading(true)
            for(const item of registerCustomerProducts){

                const isItemInList = customerProductList?.some?.((x)=>x?._id == item?._id)
                const isInProductList = item?.nonConformities?.some?.((x)=>x?._ref == nonConformity?._id)

                if(isItemInList && isInProductList){
                    console.log(`SI NON CONFORMITA' SI LISTA PRODOTTO:  ${item?.label}`)
                }
                if(!isItemInList && !isInProductList){
                    console.log("NO NON CONFORMITA' NO LISTA PRODOTTO")
                }
                if(!isItemInList && isInProductList){
                 
                    const doc = {...item, nonConformities: !Array.isArray(item?.nonConformities) ? [] : item?.nonConformities?.filter?.((x)=>x?._ref !== nonConformity?._id)}
                    console.log(`NO NON CONFORMITA' SI' LISTA PRODOTTO: ${item?.label}`, doc)
                    queue.add(() => {
                        return updateDocument({doc})
                     })
                 
                }
                if(isItemInList && !isInProductList){
                
                    const doc = {...item, nonConformities: [...item?.nonConformities, referenceDoc ]}
                    console.log(`SI LISTA NO NON CONFORMITA' PRODOTTO: ${item?.label}`, doc)
                    queue.add(() => {
                        return updateDocument({doc})
                    })
                  
                }
            }
            setLoading(false)
  
        }
        const idLaw = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.law?._id)
        const idProducts = !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(x=>x?.supplierProducts?.some?.(y=>y?._id))
        const checks = () => {
            //if(idLaw?.length > 0 ) return false
            //if(idProducts?.length > 0) return false
            return true
        }
        if(!checks()){
            errorAlert("Il prodotto non è stato salvato, ricaricare e riprovare")
            console.log("wjhdbwejhdb ERRORE SALVATAGGIO", idLaw, idProducts)
        }
        else {
            createNonConformities()?.then(()=>{
                setEditDocument(undefined) 
                setCustomerProductList([]) 
                setToggleEdit(!toggleEdit)
            })
          
        }
       
    }

    // search-box
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();
    const [searchNcValue, setSearchNcValue] = useState("");
    const searchNcRef = useRef();
    //=======================

    const testFunction = () => {
        console.log("ANALISI:", data)
        console.log("BAD PRODUCTS:", viewBadProducts())
     
        //updateDocManually()
    }
    const supplyFilter = (x) => {
        //if(supply) return x?.supply
        return !x?.supply
    }
    const nonConformititesFilter = (x) =>{
         // search-box
        const search =  x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
        if(editDocument) return x?._id == editDocument?.nonConformity?._id
        if(empty && registerTemplateFilter) return !x.informative && search && x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id && filteredCustomerProducts(x)?.length < 1 ) 
        if(empty && !registerTemplateFilter) return !x.informative && search && filteredCustomerProducts(x)?.length < 1
        if(registerTemplateFilter) return search && x?.registers?.some?.((y)=>y?._ref == registerTemplateFilter?._id) 
       
        //if(searchValue) return x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
        // ==========
        return search && x
    }
    const editNonConfAssigned = (y) => {
        if(assigned) return customerProductList?.some?.((x)=>x?._id == y?._id)
        return y
    }
    const editNonConfSearchFilter = (x) => {
        const search =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        const isRegister = x?.registers?.some?.((y)=> editDocument?.nonConformity?.registers?.some?.((z)=>z?._ref == y?._ref))
        //console.log("XXXX", editDocument?.nonConformity)
        return search && isRegister
    }
    const filteredCustomerProducts = (nonConformity) => !Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.((x)=>!Array.isArray(x?.nonConformities) ? false : x.nonConformities?.some?.((y)=>y?._ref == nonConformity?._id)) 
    //search-box
    const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearch = (e) => {
        setSearchValue(e.target.value);
      };
      const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
      };
    //==========
  if(loading)return<Loading/>
  return (
    <div className="split-view">
        <div className='new-device-container half-left' style = {{...editSizeLeft}}>
            <h2>PRODOTTI ASSEGNATI A NON CONFORMITA'</h2>
            <button onClick={testFunction}>test</button>
            <VisDiv rules={[templateRegisters]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates 
                    registerTemplateFilter={registerTemplateFilter} 
                    setRegisterTemplateFilter={setRegisterTemplateFilter} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    setLoading={setLoading}
                />
            </VisDiv>
            <h4>CERCA</h4>
            <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
            </div>
            <h4>VISUALIZZA NON CONFORMITA' SENZA PRODOTTI ASSEGNATI</h4>
            <TrueFalseToggle value={empty} onClick={() => setEmpty(!empty)} />
{/*             <h4>VISUALIZZA NON CONFORMITA' FORNITURA</h4>
            <TrueFalseToggle value={supply} onClick={() => setSupply(!supply)} /> */}

            <Divider bottom={"30px"}/>

            {
            !Array.isArray(nonConformities) ? [] : nonConformities?.filter?.(supplyFilter)?.filter?.(nonConformititesFilter)?.map?.((nonConformity)=>{
                const nonConfCustomerProducts = filteredCustomerProducts(nonConformity)
                const templateRegistersInNonConf = !Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>nonConformity?.registers?.some?.((y)=>y?._ref == x?._id))
                const nonConfTemplateRegisters = templateRegistersInNonConf?.length > 0 ? templateRegistersInNonConf : templateRegisters

                const nonConfPresidioModules = nonConfTemplateRegisters?.map?.((item)=>{
                    const modules = 
                        item?.devices
                            ?.map?.((module)=> {
                                const findModule = !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((x)=>x?._id == module?._ref)
                                //console.log("chsjcbsdjcbdsjcbdshjcb", {module, findModule, item})
                                return findModule})
                            ?.filter?.(x=>x)
                    
                    return modules
                })?.flat()
                
               
                return <NonConformityAnalysisPin 

                            key={nonConformity?._id} 
                            nonConformity={nonConformity} 
                            customerProducts={nonConfCustomerProducts}
                            setEditDocument={setEditDocument}   
                            setCustomerProductList={setCustomerProductList} 
                            setDefaultOfferMenu={setDefaultOfferMenu}
                            setNewNonConformity = {setNewNonConformity}
                            setNewCustomerProduct = {setNewCustomerProduct}
                            toggleEdit={toggleEdit}
                            setToggleEdit={setToggleEdit}
                            deviceProperties={deviceProperties}
                            presidioModules={nonConfPresidioModules}
                            templateRegisters = {nonConfTemplateRegisters}
                        />
            }
        )
        }
        </div>
        <VisDiv rules={[toggleEdit]} style = {{...editSizeRight}} className='new-device-container half-right'>
            <button
                type="button"
                className="sidebar-close-button"
                onClick={()=> {            
                    setEditDocument(undefined) 
                    setCustomerProductList([]) 
                    setToggleEdit(!toggleEdit)
                    }
                }
                >
                <AiFillCloseCircle/>
            </button>
            <div style={{marginBottom:"15px", marginTop:"15px", display:"flex", justifyContent:"center", flexDirection:"column"}}>
                <h3>{`PRODOTTI ASSEGNATI ALLA NON CONFORMITA':`}</h3>
                <h2>{`${editDocument?.nonConformity?.label}`}</h2>
                <TrueFalseToggle label={"VISUALIZZA PRODOTTI ASSEGNATI"} value={assigned} onClick={() => setAssigned(!assigned)} />
                <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                    <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
                </div>  

          
                <button type="button" style={{backgroundColor:"green"}} className="btn" onClick={updateCustomerProducts} >{LDB("misc", "save")}</button>
            </div>
            <VisDiv rules={[customerProductList]}>
                {!Array.isArray(registerCustomerProducts) ? [] : registerCustomerProducts?.filter?.(editNonConfAssigned)?.filter?.(editNonConfSearchFilter)?.sort(sortByLabel)?.map?.((item)=>{
                    //console.log("IN PIN", customerProductList)
                    const isItemInList = customerProductList?.some?.((x)=>x?._id == item?._id)
                    return (
                    <NonConformityPin
                        key = {item?._id}
                        label={item?.label}
                        item={item}
                        array={customerProductList}
                        setArray={setCustomerProductList}
                        initialValue={isItemInList}
                    />
                    )
                })}
            </VisDiv>
        </VisDiv>
    </div>
  )
}

export default AnalisiNonConformitaEProdotti

export const expandedCustomerProduct = (data) => {
    const {customerProduct, presidioModules, deviceProperties} = data
    const doc = {
        ...customerProduct,
        deviceProperties: customerProduct?.deviceProperties?.map?.((item)=> !Array.isArray(deviceProperties) ? undefined : deviceProperties?.find?.((y)=>y?._id == item?._ref)),
        devices:customerProduct?.devices?.map?.((item)=> !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((y)=>y?._id == item?._ref)),

    }
    return doc
}

export const NonConformityAnalysisPin = ({nonConformity, setDefaultOfferMenu, setNewNonConformity, setNewCustomerProduct, customerProducts, setEditDocument, setCustomerProductList, setToggleEdit, toggleEdit, presidioModules, deviceProperties, templateRegisters}) => {

        const[deviceFamily, setDeviceFamily] = useState()
        const deviceFamilies = addValueForDropdown(presidioModules)
        //console.log("nkajcnkanxkjasnckajscn", customerProducts)
        const emptyBackground = (customerProducts?.length < 1 && !nonConformity?.informative) ? {backgroundColor:"#AF7C7B"} : {}
       const filterByDevice = (x)=>{
        if(deviceFamily) return x?.devices?.some?.((y)=>y?._ref == deviceFamily?._id) || x?.devices?.length < 1 || !x?.devices
        return x
       }
       
        const editAssignment = () => {
           
            if(!toggleEdit){
                const doc = {nonConformity, customerProducts: customerProducts}
                setEditDocument(doc)
                setCustomerProductList(customerProducts)
                console.log(doc)
            }
            if(toggleEdit){
                setEditDocument(undefined)
                setCustomerProductList([]) 
                console.log(undefined)
            }
            setToggleEdit(!toggleEdit)
            
        }
        const editNonConformity = (NonConf) => {
            //console.log("lkdvhlsdjv", NonConf)
            setDefaultOfferMenu("NON CONFORMITA")
            setNewNonConformity(NonConf)
        }
        const editCustomerProduct = (customerProduct) => {
            setDefaultOfferMenu("PRODOTTI INTERNI")
            setNewCustomerProduct(customerProduct)
        }
        return(
            <div key={nonConformity?._id} style={{...emptyBackground, display:"flex", flexDirection:"column", borderRadius:"10px",border:"2px solid grey", padding:"10px", marginBottom:"10px", marginTop:"10px"}}>
                <VisDiv className='edit-button-container' style={{justifyContent:"flex-start", marginLeft:"2px"}}>
                <button type='button' className='round-back-button' style={{backgroundColor:"red"}} onClick={editAssignment}>
                    <FiEdit             
                    size={15}
                    color={"white"}/>
                </button>
                </VisDiv>
                <div style={{marginBottom:"10px", marginTop:"10px", display:"flex", alignItems:"center"}}>
                    <h3>
                        {`NON CONFORMITA': ${nonConformity?.label}`}
                    </h3>
                </div>
                <div style={{marginBottom:"10px", display:"flex", alignItems:"center"}}>
                    <button 
                        onClick={()=>editNonConformity(nonConformity)} 
                        className='red-button' 
                        style={{marginLeft:"2px", marginBottom:"5px", backgroundColor:"green"}} 
                        target="_blank" 
                        //href={`https:/gssmega.sanity.studio/desk/nonConformity;${nonConformity?._id}`}
                            >
                            MODIFICA NON CONFORMITA'
                    </button>
                </div>

                <VisDiv rules={[nonConformity?.isSign]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"amber"}>CARTELLO</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.notification]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"red"}>GRAVE</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.deadline]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"blue"}>SCADENZA</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.substitution]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"yellow"}>SOSTITUZIONE</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.supply]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"green"}>FORNITURA</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.informative]} style={{marginBottom:"15px"}}>
                    <TextHighlight highlight={"blue"}>INFORMATIVO</TextHighlight>
                </VisDiv>
                <VisDiv rules={[nonConformity?.supply]}>
                    <h4>FILTRA PER PRESIDIO:</h4>
                    <FieldDropdown
                        isSearchable="isSearchable"
                        placeHolder={"SELEZIONA PRESIDIO"}
                        options={deviceFamilies}
                        onChange={(value) => { 
                            setDeviceFamily(value)
                        }}
                    />
                </VisDiv>
                <VisDiv rules={[customerProducts?.length>0]}>
                    {"PRODOTTI: "}
                    {!Array.isArray(customerProducts) ? [] : customerProducts?.filter?.(filterByDevice)?.sort(sortByLabel)?.map?.((customerProduct)=>{
                        const expandedDoc = expandedCustomerProduct({customerProduct, deviceProperties, presidioModules})
                        //console.log("EXPANDED DOC", expandedDoc)
                        return(
                        <Fragment key={customerProduct?._id}>
                            <div style={{display:"flex", alignItems:"left", textAlign:"left", padding:"15px"}}>
                                <div style={{display:"flex", textAlign:"left", flexDirection:"column", justifyContent:"left", alignItems:"left"}}>
                                    <h4>{customerProduct?.label}</h4>
                                    <div style={{display:"flex", textAlign:"left"}}>
                                        {"PRESIDI: "}
                                        <p>{expandedDoc?.devices?.map?.(x=>` ${x?.label}`)?.toString()}</p>
                                    </div>
                                    <div style={{display:"flex", textAlign:"left"}}>
                                        <p>{`PROPRIETA': `}</p>
                                        <p>{expandedDoc?.deviceProperties?.map?.(x=>` ${x?.label}`)?.toString()}</p>
                                    </div>
                                    <VisDiv rules={[customerProduct?.substitution]} style={{marginTop:"15px"}}>
                                        <TextHighlight highlight={"yellow"}>SOSTITUZIONE</TextHighlight>
                                    </VisDiv>
                                    <VisDiv rules={[customerProduct?.supply]} style={{marginTop:"15px"}}>
                                        <TextHighlight highlight={"green"}>FORNITURA</TextHighlight>
                                    </VisDiv>
                                </div>
                            </div>
                            <button 
                                    className='red-button' 
                                    style={{marginLeft:"15px", backgroundColor:"blue"}} 
                                    onClick={()=>editCustomerProduct(customerProduct)}
                                    //target="_blank" 
                                    //href={`https:/gssmega.sanity.studio/desk/customerProduct;${customerProduct?._id}`} 
                                    >MODIFICA PRODOTTO INTERNO
                                </button>
                            <Divider bottom={"12px"}/>
                        </Fragment>
                        )
                    })}                     
                </VisDiv>

            </div>
        )
    }

